"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioBufferSchema = void 0;
const zod_1 = require("zod");
exports.audioBufferSchema = zod_1.z.object({
    kind: zod_1.z.literal("audio:buffer"),
    audioBuffer: zod_1.z.instanceof(Uint8Array),
});
//# sourceMappingURL=audioBuffer.js.map